export interface AuthState {
  authToken?: string;
  tokenExp: any;
  user?: string;
  userFamilyName?: string;
  userGivenName?: string;
  isAuthed: boolean;
  loading: boolean;
}

export interface Attribute {
  id: string;
  fixed_order: boolean;
  bucketed: boolean;
  display?: string;
  count?: number;
}
export interface Venue {
  count: number;
  id: string;
  attribute_counts: number[];
  display?: string;
}

export interface VenueWithEmbeddedProductInfo extends Venue {
  productIds: string[];
}

export interface ProductWithoutHierarchy {
  venues: Venue[];
  id: string;
  default_bucketing_set: string;
  display: string;
}

export class Product {
  public venues: Venue[];
  public id: string;
  public default_bucketing_set: string;
  public display: string;
  public displayHierarchy: string;
  public level: number;
  public directChildren: string[];
  public parent?: string;

  constructor(options: Product) {
    Object.assign(this, options);
  }
}

/* tslint:disable:max-classes-per-file */
export class ProductWithChildren extends Product {
  public directChildrenObjs: ProductWithChildren[];

  constructor(options: Product, childObjects: ProductWithChildren[]) {
    super(options);
    this.directChildrenObjs = childObjects;
  }
}

export interface ProductsMappedByID {
  [id: string]: Product;
}

export type SelectionStateOption = 'Selected' | 'Unselected' | 'Fuzzy';
export interface SelectionStateMap {
  [id: string]: SelectionStateOption;
}

export interface Bucket {
  id: string;
  type: 'regulatory' | 'custom';
  value: number[];
  name?: string;
}

export enum AsOfType {
  Relative = 'relative',
  Static = 'static'
}

export enum AsOfRelativeUnit {
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Years = 'year'
}

export interface AsOf {
  type: AsOfType;
  data: AsOfData | string;
}

export interface AsOfData {
  count: number;
  unit: AsOfRelativeUnit;
}

export interface Profile {
  sources: string[];
  types: string[];
  attributes: string[];
  buckets: {
    [id: string]: Bucket
  };
  name: string;
  id?: number;
  asOf?: AsOf;
}

export interface AttrParams {
  [productId: string]: {
    buckets: number[];
  };
}
export interface ProfileForRequest {
  sources: string[];
  types: string[];
  attributes: string[];
  attribute_params?: AttrParams;
  asOf: AsOf;
}

export interface ProfilesState {
  profileShowingOnGraph: any;
  profiles?: Profile[];
  profilesLoading: boolean;
  profileToRepopulate: any;
  profileToSave: any;
  profileToDelete: any;
  loadedProfile: any;
  selectedProfile: any;
  clearGraphStickyColumnsTrigger: number;
  clearSelectionsTrigger: number;
  asOfError?: string;
}

export interface OptionsState {
  options: any;
  productsDisplayMap: any;
  attributesDisplayMap: any;
  venuesDisplayMap: any;
  productsById: any;
  asOf: AsOf;
  minAsOf?: Date;
  maxAsOf?: Date;
}

export interface GeneralState {
  showingModal?: string;
  toastError?: string;
  toastSuccess?: string;
  toastInfo?: string;
}

export interface SelectionsState {
  selectedProduct: string;
  selectedProducts: string[];
  selectedDataSources: string[];
  selectedAttributes: string[];
  isLoadingFromProfile: boolean;
}

export interface BucketMap {
  [attributeId: string]: Bucket;
}

export interface BucketsState {
  attributeIdUnderEdit?: string;
  selectedBucketing: BucketMap;
  customBuckets: any;
}

export interface AttributeCountsState {
  queuedRequests: any;
  queryActive: boolean;
  counts: any;
}

export interface ResultsState {
  result: any;
  calculating: boolean;
  numCalculating: number;
  downloading: boolean;
  selectedGraphIndex: number;
  calculateCancelActive: boolean;
  queuedCalculateRequest: any;
  clearGraphStickyColumnsTrigger: number;
}

export interface RootState {
  auth: AuthState;
  profiles: ProfilesState;
  general: GeneralState;
  options: OptionsState;
  selections: SelectionsState;
  attributeCounts: AttributeCountsState;
  results: ResultsState;
  buckets: BucketsState;
}
